/* eslint-disable react/jsx-props-no-spreading */
import { Typography, TagName } from 'palette/Typography';
import { HeaderProps } from '../types';

function Header({ level, ...restProps }: React.PropsWithChildren<Omit<HeaderProps, 'type'>>) {
    return (
        <Typography
            level={level}
            tagName={`h${level}` as TagName}
            type="header"
            {...restProps}
        />
    );
}

export default Header;
